import {
  AlertCircle,
  CheckCircle2,
  FileSpreadsheet,
  XCircle,
} from "lucide-react";
import { useTran } from "@/hooks";
import {
  getBatchUploadBreakdownItems,
  getBatchUploadValidBreakdown,
} from "../../utils/batchUploadSummary";
import { BatchUploadSummaryItems } from "./BatchUploadBadges";
import SheetPreviewTable from "./SheetPreviewTable";

const ParsePreview = ({ result }) => {
  const { t } = useTran();
  const { summary, sheets, uploadValidation } = result;
  const validBreakdown = getBatchUploadValidBreakdown(summary);
  const breakdownItems = getBatchUploadBreakdownItems(validBreakdown);

  return (
    <div className="space-y-4">
      {uploadValidation?.message && (
        <div
          className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${
            uploadValidation.code === "EMPTY_UPLOAD" ||
            uploadValidation.code === "DUPLICATE_FILE"
              ? "border-destructive/30 bg-destructive/10 text-destructive"
              : "border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-300"
          }`}
        >
          <AlertCircle size={16} className="mt-0.5 shrink-0" />
          <span>{t(uploadValidation.message)}</span>
        </div>
      )}

      <div className="flex items-center gap-3 rounded-lg border border-border bg-muted/30 p-3">
        <FileSpreadsheet size={20} className="text-muted-foreground shrink-0" />
        <div className="flex-1 flex flex-wrap items-center gap-3 text-sm">
          {validBreakdown.hasBreakdown ? (
            <BatchUploadSummaryItems items={breakdownItems} />
          ) : summary.totalValid > 0 ? (
            <span className="inline-flex items-center gap-1 text-green-600 dark:text-green-400">
              <CheckCircle2 size={14} />
              {t("{{count}} valid", { count: summary.totalValid })}
            </span>
          ) : null}
          {summary.totalErrors > 0 && (
            <span className="inline-flex items-center gap-1 text-destructive">
              <XCircle size={14} />
              {t("{{count}} errors", { count: summary.totalErrors })}
            </span>
          )}
        </div>
      </div>

      <div className="space-y-3 max-h-[400px] overflow-y-auto">
        {sheets.map((sheet) => (
          <SheetPreviewTable key={sheet.sheetName} sheet={sheet} />
        ))}
      </div>
    </div>
  );
};

export default ParsePreview;
